import { Navigate } from 'react-router'

import {
  FeedbackNetworkError,
  FeedbackUnknownError,
} from '@/components/feedbacks'
import { LoadingComponent } from '@/components/loading'

import { useHydrateUser } from './use-hydrate-user'

export function UserHydrator({ children }: { children: React.ReactNode }) {
  const { state, userId, retry } = useHydrateUser()

  if (!userId) {
    throw new Error('[UserHydrator]: Missing user id')
  }

  if (state.type === 'loading') {
    return <LoadingComponent />
  }

  if (state.type === 'error' && state.errorType === 'UNAUTHORIZED') {
    return <Navigate to="/login" replace />
  }

  if (state.type === 'error' && state.errorType === 'USER_INACTIVE') {
    return <Navigate to="/login" replace /> // FEEDBACK USER INACTIVE WITH TRANSLATIONS IN THE NEXTS PR
  }

  if (state.type === 'error' && state.errorType === 'NETWORK_ERROR') {
    return (
      <div className="flex min-h-screen w-full items-center justify-center">
        <FeedbackNetworkError eventId={state.eventId} onRetry={retry} />
      </div>
    )
  }

  if (state.type === 'error') {
    return (
      <div className="flex min-h-screen w-full items-center justify-center">
        <FeedbackUnknownError eventId={state.eventId} onRetry={retry} />
      </div>
    )
  }

  return children
}
